import { FormattedMessage as Message } from 'react-intl';
import type { TpFormattedMessage } from '../../types';
import styles from './index.module.css';
export const FormattedMessage = (props: TpFormattedMessage) => {
  const {
    defaultMessage,
    id,
    values,
    ...otherProps
  } = props;
  return <span data-trans={id} className={styles.message} data-sentry-component="FormattedMessage" data-sentry-source-file="index.tsx">
      <Message data-trans={id} id={id} values={{
      br: <br />,
      ...values
    }} defaultMessage={defaultMessage} {...otherProps} data-sentry-element="Message" data-sentry-source-file="index.tsx" />
    </span>;
};